module.exports = __webpack_public_path__ + "static/img/k8.8e330bcb.png";